/**
 * Test ID utilities for the IntensitySection component.
 *
 * Pattern: all test IDs are generated via named setter functions so component
 * and tests can never drift apart.
 */

import { generateTestId } from "@client-shared";

export const setIntensitySectionTestId = (identifier: string): string => generateTestId("IntensitySection", identifier);

/**
 * Sentinel for the "no coffee picked" option in the most-similar-to select.
 * Radix rejects an empty-string item value, so the cleared state needs a
 * placeholder the roaster can select to undo their choice.
 */
export const NO_COMPARISON_COFFEE = "__none__";

/**
 * The dropdown's controlled value: the picked coffee when there is one, the
 * empty string (Radix shows the placeholder) for a score that has no usable
 * pick, and the no-coffee sentinel only when nothing is scored. The sentinel
 * must not be shown for an orphaned score — selecting the value a Select
 * already holds fires no change, so the roaster could never clear it.
 */
export const resolveMostSimilarTo = (pick: string | null | undefined, hasScore: boolean): string => {
  if (pick) return pick;
  return hasScore ? "" : NO_COMPARISON_COFFEE;
};
